export default __webpack_public_path__ + "media/zurb/img/playground/kelvin-portrait-hero-c9baa31d92001d286dc302eafeefc956.jpg";